import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {AccountBox, Logout, Settings} from '@mui/icons-material';
import LanguageIcon from '@mui/icons-material/Language';
import PollIcon from '@mui/icons-material/Poll';
import {SxProps, Typography, useTheme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import {AppHeaderWrapper} from '../AppHeaderWrapper';
import {SideDrawerWrapper} from '../SideDrawerWrapper';

import {AppConfig} from '../../../../lib/AppConfig';
import {AppRouteResource} from '../../../../types/AppRouteResource';
import {AvatarDropDownMenu} from '../../../AvatarDropDownMenu/AvatarDropDownMenu';
import {EmpionButton} from '../../../EmpionButton/EmpionButton';

const applicantButtonsStyles: SxProps = {
  padding: 2,
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
    backgroundImage: 'none',
    boxShadow: 'none',
  },
};

const profileRoute: AppRouteResource = {
  label: 'appHeader.menuLabels.profile',
  icon: <AccountBox />,
  navigationPath: AppConfig.APPLICANT_PROFILE_PATH,
};

const cultureRoutes: AppRouteResource[] = [
  {
    label: 'appHeader.menuLabels.applicant.matches',
    icon: <LanguageIcon />,
    navigationPath: AppConfig.DASHBOARD_PATH,
  },
  {
    label: 'appHeader.menuLabels.applicant.culture',
    icon: <PollIcon />,
    navigationPath: AppConfig.APPLICANT_CULTURE_PATH,
  },
];

const generalRoutes: AppRouteResource[] = [
  {
    label: 'appHeader.menuLabels.settings',
    icon: <Settings />,
    navigationPath: AppConfig.ACCOUNT_SETTINGS_PATH,
  },
  {
    label: 'appHeader.menuLabels.logout',
    icon: <Logout />,
    navigationPath: AppConfig.LOGOUT_PATH,
  },
];

export const ApplicantAppHeader = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  if (isSmallScreen) {
    return (
      <SideDrawerWrapper
        sideBarSections={[{menuItems: [profileRoute]}, {menuItems: cultureRoutes}, {menuItems: generalRoutes}]}
      />
    );
  }

  return (
    <AppHeaderWrapper isTransparent={false}>
      <EmpionButton
        variant='menu'
        disableRipple
        sx={applicantButtonsStyles}
        onClick={() => {
          navigate(AppConfig.APPLICANT_DASHBOARD_PATH);
        }}
      >
        <Typography variant='h4'>{t('appHeader.menuLabels.applicant.matches')}</Typography>
      </EmpionButton>
      <EmpionButton
        variant='menu'
        disableRipple
        sx={applicantButtonsStyles}
        onClick={() => {
          navigate(AppConfig.APPLICANT_CULTURE_PATH);
        }}
      >
        <Typography variant='h4'>{t('appHeader.menuLabels.applicant.culture')}</Typography>
      </EmpionButton>
      <AvatarDropDownMenu />
    </AppHeaderWrapper>
  );
};
